/** (型号功能管理页)设备型号、对应功能、设备发送指令相关接口方法
 */
const devModelCtl = {
  /** 查询型号功能
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  listDevModFun (_this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        pageNum: _this.currentPage,
        pageSize: _this.pagesize
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.totalNum = res.data.data.total
        _this.devModelTableData = res.data.data.pag
        _this.tableloading = false
      } else {
        console.log(res)
      }
    })
  },
  /** 根据型号id查询所有功能
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getAllFunByModId (_this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        modId: _this.selDevModel
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.functionData = res.data.data
      }
    })
  },
  /** 根据型号id修改型号功能
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param funIds {string} 功能id字符串，英文逗号分割，末尾没有逗号
   */
  updateDevModFun (_this, url, funIds) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        modId: _this.selDevModel,
        funIds: funIds
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '操作成功！',
          type: 'success'
        })
        _this.setFunctionToDevModelDialogVisible = false
        _this.$parent.getDevModelList()
      } else {
        console.log(res)
      }
    })
  },
  /** 新增型号功能
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  addDevModFun (_this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        modId: _this.creatFrom.modId,
        funIds: _this.creatFrom.funId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '操作成功！',
          type: 'success'
        })
        _this.creatDevModFunDialogVisible = false
        _this.$parent.getDevModelList()
      } else {
        console.log(res)
      }
    })
  },
  /** 根据型号id删除型号功能
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  delDevModFun (_this, url, modIds) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        modIds: modIds
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '删除成功！',
          type: 'success'
        })
        _this.getDevModelList()
      } else {
        console.log(res)
      }
    })
  }
}
export default devModelCtl



// WEBPACK FOOTER //
// ./src/javascript/function/devModelFuntion.js